(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessibility-widget"] && !Shopify.designMode) return;
  try {
    (function () {
      var root = document.documentElement;
      var KEY = 'akik-a11y';
      var FLAGS = ['contrast', 'links', 'readable', 'spacing', 'motion', 'cursor'];
      var state = { scale: 1 };
      try { state = Object.assign(state, JSON.parse(localStorage.getItem(KEY) || '{}')); } catch (e) {}

      var wrap = document.getElementById('a11y');
      if (!wrap) return;
      var launcher = wrap.querySelector('[data-a11y-open]');
      var panel = wrap.querySelector('[data-a11y-panel]');
      var overlay = wrap.querySelector('[data-a11y-overlay]');

      function apply() {
        var s = Number(state.scale) || 1;
        root.style.setProperty('--font-scale', s);
        FLAGS.forEach(function (f) { root.classList.toggle('a11y-' + f, !!state[f]); });
        wrap.querySelectorAll('[data-a11y-toggle]').forEach(function (b) {
          b.setAttribute('aria-pressed', !!state[b.getAttribute('data-a11y-toggle')]);
        });
        var lbl = wrap.querySelector('[data-a11y-scale-val]');
        if (lbl) lbl.textContent = Math.round(s * 100) + '%';
      }
      function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

      function open(o) {
        wrap.classList.toggle('is-open', o);
        launcher.setAttribute('aria-expanded', o ? 'true' : 'false');
        panel.hidden = !o;
        overlay.hidden = !o;
        if (o) { panel.focus(); }
        else { launcher.focus(); }
      }

      // Hem yuzen ikon hem footer'daki [data-a11y-open] butonu ayni paneli acar.
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-a11y-open]')) {
          e.preventDefault();
          open(!wrap.classList.contains('is-open'));
        }
      });
      overlay.addEventListener('click', function () { open(false); });
      wrap.querySelectorAll('[data-a11y-close]').forEach(function (b) {
        b.addEventListener('click', function () { open(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wrap.classList.contains('is-open')) open(false);
      });

      wrap.querySelectorAll('[data-a11y-toggle]').forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-a11y-toggle');
          state[f] = !state[f];
          apply(); save();
        });
      });
      wrap.querySelector('[data-a11y-scale-dec]').addEventListener('click', function () {
        state.scale = Math.max(1, Math.round(((Number(state.scale) || 1) - 0.1) * 10) / 10);
        apply(); save();
      });
      wrap.querySelector('[data-a11y-scale-inc]').addEventListener('click', function () {
        state.scale = Math.min(1.6, Math.round(((Number(state.scale) || 1) + 0.1) * 10) / 10);
        apply(); save();
      });
      wrap.querySelector('[data-a11y-reset]').addEventListener('click', function () {
        state = { scale: 1 };
        apply(); save();
      });

      apply();
    })();
  } catch(e) { console.error(e); }
})();

})();
